<template>
  <div class="flex-grow-1" @click.prevent>
    <VueMonthlyPicker :id="inputId" v-model="internalValue" :monthLabels="monthLabels" dateFormat="YYYY-MM" />
  </div>
</template>

<script>

import formInputFieldMixin from './mixins/formInputField';
import formInputTextPropsMixin from './mixins/formInputTextProps';

export default {
  mixins: [formInputFieldMixin, formInputTextPropsMixin],
  components: {
    VueMonthlyPicker: () => import('vue-monthly-picker'),
  },
  data () {
    return {
      monthLabels: [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic',
      ],
    };
  },
  computed: {
    internalValue: {
      get () {
        return this.value;
      },
      set (newValue) {
        if (!newValue) {
          this.$emit('input', null);

          return;
        }

        this.$emit('input', newValue.format('YYYY-MM'));
      },
    },
  },
};

</script>

<style lang="scss">

.vue-monthly-picker {
  .month-picker-wrapper {
    min-width: auto !important;
  }

  .date-popover {
    min-width: 200px;
  }

  .picker .monthItem .item.selected {
    background-color: $primary !important;
  }
}

</style>
